import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { usePanelPosition } from '../contexts/PanelPositionContext';
import { X } from 'lucide-react';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import SortablePanel from './SortablePanel';

interface LeftPanelProps {
  isLeftPanelVisible: boolean;
  onClose: () => void;
  leftPanels: Array<{
    id: string;
    title: string;
    component: React.ReactNode;
  }>;
  leftPanelsOrder: string[];
}

const LeftPanel: React.FC<LeftPanelProps> = ({
  isLeftPanelVisible,
  onClose,
  leftPanels,
  leftPanelsOrder,
}) => {
  const { theme } = useTheme();
  const { isPanelOnRight } = usePanelPosition();

  if (!isLeftPanelVisible) return null;
  // pb-[60px] 
  return (
    <div className={`group/panel w-64 min-w-64 max-w-64 opacity-100 px-2 ${theme === 'light' ? 'theme-bg-secondary' : ''} theme-border ${isPanelOnRight ? 'border-l' : 'border-r'} space-y-2 overflow-hidden overflow-y-auto h-screen flex-shrink-0 transition-all duration-300 ease-in-out scrollbar-hide relative`}>
      {/* Close Button - Only visible while the panel is hovered. The group is named so it does
          not also drive the hover-revealed controls the panels inside carry. */}
      <div className="flex items-center justify-end mb-0 absolute top-1 right-2 z-30 opacity-0 pointer-events-none transition-opacity duration-200 group-hover/panel:opacity-100 group-hover/panel:pointer-events-auto focus-within:opacity-100 focus-within:pointer-events-auto" style={{ top: '7px' }}>
        <button
          onClick={onClose}
          className="p-1 rounded-sm transition-all duration-200"
          title="Close panel"
        >
          <X className="h-3 w-3 theme-text-quaternary group-hover:text-white transition-colors duration-200" />
        </button>
      </div>
      
      <SortableContext
        items={leftPanelsOrder}
        strategy={verticalListSortingStrategy}
      >
        {leftPanelsOrder.map((panelId) => {
          const panel = leftPanels.find(p => p.id === panelId);
          return panel ? <SortablePanel key={panel.id} panel={panel} /> : null;
        })}
      </SortableContext>
    </div>
  );
};

export default LeftPanel;
